import { ZoomSchedulePage } from './zoom-schedule-page'

export default ZoomSchedulePage
